import { useGetCrmConfiguration } from '../../api/settingsService';
import { ExternalRecordLinkConfig } from './getExternalRecordUrl';

// Stable reference so callers memoizing on this hook's result (e.g. a table's
// column context) don't rebuild on every render while the query is loading.
const EMPTY_LINK_CONFIG: ExternalRecordLinkConfig = {};

/**
 * Salesforce and HubSpot are the only external systems whose record URLs the
 * frontend can construct today (see getExternalRecordUrl). Same query + key
 * as useIntegrationInfo's CRM check, so mounting both on a page costs one
 * request, not two.
 */
export function useCrmRecordLinkConfig(): ExternalRecordLinkConfig {
  const { data } = useGetCrmConfiguration({
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnMount: false,
    select: (crmConnection) => ({
      salesforceInstanceUrl: crmConnection.salesforce?.instanceUrl,
      hubspotPortalId: crmConnection.hubspot?.hubId,
    }),
  });
  return data ?? EMPTY_LINK_CONFIG;
}
